import { Col, DatePicker, Row } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import { getAlternateUsers } from '../../redux/actions/alternate-user';
import UserSearchSelect from '../UserSearchSelect';


const AlternateUserFilter = ({ onFiltersChange }) => {
    const [filters, setFilters] = useState({
        primary_user_id: undefined,
        secondary_user_id: undefined,
        start_date: null,
        end_date: null,
    });


    const onFilterChange = (updatedFilter) => {
        const newFilters = { ...filters, ...updatedFilter };

        const formattedFilters = {
            ...newFilters,
            start_date: newFilters.start_date
                ? dayjs(newFilters.start_date).format("YYYY-MM-DD")
                : undefined,
            end_date: newFilters.end_date
                ? dayjs(newFilters.end_date).format("YYYY-MM-DD")
                : undefined,
        };

        setFilters(formattedFilters);
        getAlternateUsers(formattedFilters);
        onFiltersChange?.(formattedFilters);
    };

    return (
        <Row gutter={[10, 10]} style={{ width: '100%' }}>
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <UserSearchSelect
                    showUnassigned={false}
                    placeholder='Search primary user'
                    onChange={(value) => onFilterChange({ primary_user_id: value })}
                />
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <UserSearchSelect
                    showUnassigned={false}
                    placeholder='Search secondary user'
                    onChange={(value) => onFilterChange({ secondary_user_id: value })}
                />
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <DatePicker
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="Start date"
                    onChange={(date) => onFilterChange({ start_date: date })}
                />
            </Col>
            <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                <DatePicker
                    size="large"
                    style={{ width: '100%' }}
                    placeholder="End date"
                    onChange={(date) => onFilterChange({ end_date: date })}
                />
            </Col>
        </Row>
    );
};

export default AlternateUserFilter;
